import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Markets from "./pages/Markets";
import Bots from "./pages/Bots";
import Trades from "./pages/Trades";
import Portfolio from "./pages/Portfolio";
import History from "./pages/History";
import Signals from "./pages/Signals";
import Settings from "./pages/Settings";
import BillingSuccess from "./pages/BillingSuccess";
import Admin from "./pages/Admin";
import Terms from "./pages/legal/Terms";
import Privacy from "./pages/legal/Privacy";
import Risk from "./pages/legal/Risk";
import Disclaimer from "./pages/legal/Disclaimer";
import CookiesPolicy from "./pages/legal/Cookies";
import CookieBanner from "./components/CookieBanner";

function ProtectedShell() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500" data-testid="auth-loading">
        <div className="text-sm label-xs">Loading session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout><Outlet /></Layout>;
}

function AdminGuard() {
  const { user } = useAuth();
  if (!user || user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" />
          <CookieBanner />
          <Routes>
            <Route path="/legal/terms" element={<Terms />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/risk" element={<Risk />} />
            <Route path="/legal/disclaimer" element={<Disclaimer />} />
            <Route path="/legal/cookies" element={<CookiesPolicy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route element={<ProtectedShell />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/bots" element={<Bots />} />
              <Route path="/trades" element={<Trades />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/history" element={<History />} />
              <Route path="/signals" element={<Signals />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/billing/success" element={<BillingSuccess />} />
              <Route element={<AdminGuard />}>
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
